export async function apiFetch(url, options = {}) {
    let res = await fetch(url, {
        ...options,
        credentials: 'include',
    });

    if (res.status === 401) {
        // tente refresh
        const refresh = await fetch('/auth/refresh', {
            method: 'POST',
            credentials: 'include',
        });

        if (refresh.ok) {
            // retry
            res = await fetch(url, {
                ...options,
                credentials: 'include',
            });
        } else {
            // session morte
            window.location.href = '/auth-login';
            throw new Error('Session expirée');
        }
    }

    return res;
}


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license